import { configureStore } from '@reduxjs/toolkit';
import createSagaMiddleware from 'redux-saga';
import { notificationSlice } from './containers/Notifications/slice';
import { rootSaga } from './root-saga';
import { portalSlice } from './layouts/MainLayout/slice';
import { chatSlice } from './containers/chat/slice';
import { loginSlice } from './containers/login/slice';
import { adminSlice } from './layouts/AdminLayout/slice';
import { adminDashboardSlice } from './containers/adminDashboard/slice';
import { usersSlice } from './containers/users/slice';
import { knowledgeBaseSlice } from './containers/knowledgeBase/slice';

export const sagaMiddleware = createSagaMiddleware();

const store = configureStore({
  reducer: {
    [notificationSlice.name]: notificationSlice.reducer,
    [portalSlice.name]: portalSlice.reducer,
    [chatSlice.name]: chatSlice.reducer,
    [loginSlice.name]: loginSlice.reducer,
    [adminSlice.name]: adminSlice.reducer,
    [adminDashboardSlice.name]: adminDashboardSlice.reducer,
    [usersSlice.name]: usersSlice.reducer,
    [knowledgeBaseSlice.name]: knowledgeBaseSlice.reducer,
  },
  devTools: true,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({ serializableCheck: true }).concat(sagaMiddleware),
});

sagaMiddleware.run(rootSaga);

export default store;
